// @flow

import type { NurseDeclinedReasonsState } from "./types";

export const initialState: NurseDeclinedReasonsState = {
  requestsInProgress: 0,
  schema: null,
  list: null,
  current: null,
  draft: null,
  configuration: {
    enabled: true,
  },
  modals: {
    showAddModal: false,
    showEditModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
};

export default initialState;
